const musicLinkUrlPartsNL = {
    "view": {
        "table": {
            "title": "Uw muzieklink-URL-deel lijst",
            "column": {
                "part": "Deel",
                "owner": "Eigenaar",
                "action": "Actie"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "button": {
                "exportCSV": "Exporteer CSV"
            }
        },
        "message": {
            "success": "Muzieklink-URL-deel is verwijderd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "noUrlparts": "Momenteel wordt deze functie alleen aangeboden aan enkele geselecteerde gebruikers, maar het goede nieuws is dat u het binnenkort ook kunt gebruiken. Blijf deze ruimte in de gaten houden!"
        },
        "modal": {
            "delete": {
                "header": "Verwijder {{mlUrlpart}}?",
                "body": "Weet u zeker dat u dit muzieklink-URL-deel wilt verwijderen?"
            },
            "canNotDelete": {
                "header": "Kan muzieklink-URL-deel {{mlUrlPart}} niet verwijderen",
                "body": "Muzieklink-URL-deel {{mlUrlPart}} kan niet worden verwijderd omdat het al is gekoppeld aan een muzieklink."
            }
        }
    },
    "add": {
        "form": {
            "label": {
                "subUser": "Sub-gebruiker",
                "part": "Deel",
                "owner": "Eigenaar",
                "addUrlPart": "Voeg URL-deel toe",
                "editUrlPart": "Bewerk URL-deel"
            },
            "placeholder": {
                "subUser": "Selecteer sub-gebruiker..."
            },
            "help_text": {
                "subUser": "Opmerking: Gebruik deze dropdown alleen als u een muzieklink wilt toevoegen voor een van uw sub-gebruikers, anders laat u deze on geselecteerd."
            },
            "button": {
                "reset": "Reset",
                "submit": "Verzenden"
            },
            "validation": {
                "part": {
                    "required": "Deel is vereist",
                    "max": "Moet precies 16 tekens zijn"
                }
            },
            "message": {
                "subUserLimit": "Deze sub-gebruiker heeft de maximale limiet van 10 URL-delen bereikt.",
                "urlPartAlreadyTaken": "Deze muzieklink-URL is al in gebruik door uw account of een ander gebruikersaccount. Probeer iets anders."
            }
        },
        "message": {
            "addSuccess": "Muzieklink-URL-deel is toegevoegd!",
            "updateSuccess": "Muzieklink-URL-deel is bijgewerkt!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        }
    }
};

export default musicLinkUrlPartsNL;